import { SlideUpModal } from "src/components/SlideUpModal";
import { useDlaFormSubmit } from "src/hooks/useDlaFormSubmit";
import { useWebClientApi } from "src/api";

type DeleteEmploymentModalProps = {
  isOpen: boolean;
  employment_id: string;
  closeHandler: () => void;
  deleteHandler: () => void;
};

export default ({
  isOpen,
  employment_id,
  closeHandler,
  deleteHandler,
}: DeleteEmploymentModalProps) => {
  const api = useWebClientApi();
  const [submitDelete, loading] = useDlaFormSubmit(
    async () => {
      await api.deleteEmployment(employment_id);
    },
    {
      onSuccess: () => deleteHandler(),
    },
  );

  if (!isOpen) return null;

  return (
    <SlideUpModal
      title="Remove this employment"
      isOpen={isOpen}
      closeHandler={closeHandler}
      hasDismissButton={true}
      actionButtonText="Remove"
      actionButtonClickHandler={() => void submitDelete({})}
      isLoading={loading}
    >
      This action cannot be undone.
    </SlideUpModal>
  );
};
